module.exports = __webpack_public_path__ + "static/media/wegroup-logo.234b6422.svg";